<template>
  <el-dialog
    :visible="visible"
    width="470px"
    custom-class="robot-power-confirm"
    :show-close="false"
    :close-on-click-modal="!submitting"
    :close-on-press-escape="!submitting"
    @close="$emit('update:visible', false)"
  >
    <div class="robot-power-confirm__head">
      <strong>关闭机器人</strong>
      <button
        type="button"
        aria-label="关闭"
        :disabled="submitting"
        @click="$emit('update:visible', false)"
      >
        ×
      </button>
    </div>

    <div class="robot-power-confirm__warning">
      {{ message }}
    </div>
    <p>{{ prompt }}</p>

    <div class="robot-power-confirm__actions">
      <button
        class="is-cancel"
        type="button"
        :disabled="submitting"
        @click="$emit('update:visible', false)"
      >
        取消
      </button>
      <button
        class="is-confirm"
        type="button"
        :disabled="submitting"
        @click="$emit('confirm')"
      >
        <i v-if="submitting" class="el-icon-loading" />
        {{ submitting ? '正在关闭' : '确定关闭' }}
      </button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'RobotPowerConfirmModal',
  props: {
    visible: { type: Boolean, default: false },
    message: { type: String, required: true },
    prompt: { type: String, default: '确定要关闭机器人吗？' },
    submitting: { type: Boolean, default: false }
  }
}
</script>

<style scoped>
.robot-power-confirm__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.robot-power-confirm__head strong {
  color: #182033;
  font-size: 18px;
  font-weight: 800;
}

.robot-power-confirm__head button {
  width: 30px;
  height: 30px;
  display: grid;
  place-items: center;
  padding: 0;
  color: #8a90a0;
  border: 0;
  border-radius: 8px;
  background: transparent;
  font-size: 20px;
  cursor: pointer;
}

.robot-power-confirm__head button:hover {
  background: #f5f6f9;
}

.robot-power-confirm__warning {
  margin-bottom: 14px;
  padding: 12px 14px;
  color: #b42318;
  border-radius: 8px;
  background: #fceae8;
  font-size: 13px;
  line-height: 1.7;
}

.robot-power-confirm p {
  margin: 0 0 20px;
  color: #3a3f4e;
  font-size: 14.5px;
  font-weight: 700;
}

.robot-power-confirm__actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.robot-power-confirm__actions button {
  min-width: 98px;
  padding: 10px 26px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 700;
  white-space: nowrap;
  cursor: pointer;
}

.robot-power-confirm__actions .is-cancel {
  color: #3a3f4e;
  border: 1px solid #dcdfe8;
  background: #fff;
}

.robot-power-confirm__actions .is-confirm {
  color: #fff;
  border: 1px solid #e5484d;
  background: #e5484d;
}

.robot-power-confirm__actions .is-confirm:hover {
  border-color: #c93a3e;
  background: #c93a3e;
}

.robot-power-confirm__actions button:disabled,
.robot-power-confirm__head button:disabled {
  cursor: not-allowed;
  opacity: .65;
}
</style>

<style>
.robot-power-confirm .el-dialog__header,
.robot-power-confirm .el-dialog__footer {
  display: none;
}

.robot-power-confirm .el-dialog__body {
  padding: 24px;
}
</style>
